import { useQuery } from 'react-query';

import { getClient } from '@/lib/restClient';
import {
  MosPosMenuListData,
  MosPosMenuMasterService,
} from '@/services/MosPosMenuMaster';

/** SCR009 の一覧クエリキー。import 成功後にこのキーを invalidate します。 */
export const MOS_POS_MENU_MASTER_QUERY_KEY = ['mos-pos-menu-masters'];

/**
 * menu graph 全体を1回だけ取得します。検索・絞り込み・展開は全てクライアント側で
 * 行うため、詳細取得 API は呼びません。
 */
export const useMosPosMenuMasterList = (enabled = true) =>
  useQuery<MosPosMenuListData, Error>(
    MOS_POS_MENU_MASTER_QUERY_KEY,
    async () => {
      const service = new MosPosMenuMasterService(getClient());
      return await service.fetchList();
    },
    {
      enabled,
      // 展開や絞り込みで再取得されないようにします。
      refetchOnWindowFocus: false,
    }
  );
